import * as React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import GatsbyImage from 'gatsby-image';

import { useGraphQL } from '../hooks';

function Team() {
  const { heroTeamImage } = useStaticQuery(graphql`
    {
      heroTeamImage: file(relativePath: { eq: "about/our-team.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1280) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  const {
    site: {
      siteMetadata: { title },
    },
  } = useGraphQL();
  return (
    <article className="relative bg-white">
      <GatsbyImage fluid={heroTeamImage.childImageSharp.fluid} />
      <div className="px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="sm:border sm:py-12 sm:pb-24 sm:px-6 lg:px-8 lg:pt-16">
          <h2 className="h2">The Team Behind {title}</h2>
          <div aria-hidden className="flex w-1/3 h-3 mt-6 overflow-hidden">
            <div className="w-1/2 bg-brand-pink">
              <div className="h-full transform -skew-x-12 bg-brand-pink" />
            </div>
            <div className="w-1/2 bg-brand-blue">
              <div className="h-full transform -skew-x-12 bg-brand-blue" />
            </div>
          </div>
          <div className="grid gap-8 mt-8 lg:grid-cols-2">
            <div className="prose">
              <p>
                Chantale and Gordon McCallum are accredited PGA Professional
                Golfers with over 30 years of experience in golfing in Scotland,
                Germany, and Australia.
              </p>
              <p>
                Chantale and Gordon recognised that options for women golfers in
                traditional golf stores weren’t balanced for both men and women
                golfers. This led to the creation of Golf Ladies First, a shop
                focused on assisting women golfers with a larger range of
                apparel, fashion, and accessories.
              </p>
              <p>
                Chantale and Gordon continue this tradition in {title}, giving
                all golfers, men and women, opportunities to ask questions,
                discuss their needs, and get a helping hand when it comes to the
                finer points of the game.
              </p>
            </div>
            <div className="prose">
              <p>
                The team at {title} curate a highly expansive and diverse range
                of golf apparel and accessories from the world’s best brands
                based on their own experiences as pro golfers. {title}
                ’s team are always on hand to order special items to improve
                your game.
              </p>
              <p>
                {title} uses a collaborative approach when customers approach us
                with fitting, sizing, and other queries. Chantale and Gordon
                draw on their experience to come up with a solution, keeping in
                constant communication with new and cherished return customers
                until they find your perfect product or accessory.
              </p>
              <p>
                Want to improve your game? Chantale and Gordon also write a
                monthly newsletter with tips they’ve picked up on the links both
                in Australia and across the world.{' '}
                <a href="#signup" className="font-bold text-gray-900 underline">
                  Click here
                </a>{' '}
                to sign up.
              </p>
            </div>
          </div>
          <div className="max-w-3xl lg:mx-auto lg:text-center">
            <h2 className="mt-24 h2">
              Get the Best in Fashion and Golf Accessories at {title}
            </h2>
            <div className="mt-6 prose">
              <p>
                {title} boasts one of the largest and highest quality
                collections of golf fashion, apparel, and accessories in
                Australia. Can’t find it here? We can source it and have it
                dispatched to you right away.
              </p>
              <p>
                <Link
                  to="/contact/"
                  className="font-bold text-gray-900 underline"
                >
                  Click here to contact us.
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export { Team };
